import React, { useEffect, useLayoutEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setGlobalLoader } from "../../../redux/slices/globalLoader";
import { setTitle } from "../../../utils/commonfunction";
import UserHeader from "./header";
import UserFooter from "./footer";

function UserFrontLayout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  window.navigate_ = navigate;

  return (
    <div className="site-bg">
      <UserHeader />
      <div className="inner-wraper">
        <Outlet />
      </div>
      <UserFooter />
    </div>
  );
}

export default UserFrontLayout;
